/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateMerchantAddresses} from '../api'

export const useMutationUpdateMerchantAddresses = createReactQueryMutationHook('updateMerchantAddresses', updateMerchantAddresses)
